import { styled } from '../../Styles/stitches.config'
import { StyledHeading } from '../../Atoms/Heading'
import { StyledSVG } from '../../Atoms/SVG/styles'

export const StyledIconHeadingBtn = styled('div', {
    border: '1px solid $primary600',
    br: '$2',
    display: 'grid',
    w: '100px',
    fontWeight: 'bold',
    whiteSpace: 'pre-line',
    fontSize: 13,
    p: '$2',

    [`& ${StyledSVG}`]: {
        color: '$primary600',
        fontSize: 20,
    },
    [`& ${StyledHeading}`]: {
        fontWeight: 'bold',
        mb: '-$1',
    },

    variants: {
        active: {
            true: {},
        },
        variant: {
            IconHeadingBtnDark: {
                color: '$primary400',
                [`& ${StyledHeading}`]: {
                    color: '$primary600',
                },
            },
            IconHeadingBtnLight: {
                border: '1px solid $primary400',
                color: '$primary600',

                [`& ${StyledSVG}`]: {
                    color: '$primary400',
                },
                [`& ${StyledHeading}`]: {
                    color: '$primary400',
                },
            },
        },
    },

    compoundVariants: [
        {
            variant: 'IconHeadingBtnDark',
            active: true,
            css: {
                border: '1px solid $primary600',
                bgc: '$primary600',
                color: 'white',
                [`& ${StyledSVG}`]: {
                    color: 'white',
                },
                [`& ${StyledHeading}`]: {
                    color: 'white',
                },
            },
        },
        {
            variant: 'IconHeadingBtnLight',
            active: true,
            css: {
                border: '1px solid $primary600',
                bgc: '$primary600',
                color: 'white',
                [`& ${StyledSVG}`]: {
                    color: 'white',
                },
                [`& ${StyledHeading}`]: {
                    color: 'white',
                },
            },
        },
    ],
})
